import React from 'react';
import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import {
  Main, FindId, NotFound,
  Terms, Signup, Verify,
  SafetyEducation, SafetyManagement, SafetyRisk, SafetyWorker,
  LectureList, LectureDetail, ApplyOnline,
  InquiryList, InquiryRegist, InquiryDetail, InquiryModify,
  NoticeList, NoticeDetail, 
  Qna, 
  ReferenceList, ReferenceDetail,
  MyLecturesStudent, MyCompletionStudent, MyStudentLectureDetail, MyStudentProfile, MyPasswordStudentPage,
  MainAdmin,
  Company, Integration, Instructor, InstructorResult,
  Member, Inquiry, Notice, Reference,
  MemberExcelRegist,
  Lecture, LectureForm, LectureDetails, LectureStudent, LectureAttendance, LectureApply, LectureInvoice,
  Invoice,
  LoginPage, PaymentComplete, PaymentFail, RefundComplete, RefundFail,

} from '@pages';
import {ProtectedRoute, ProtectedSignupRoute, ProtectedVerifyRoute, Layout, SignupLayout, ProtectedStudentProfileRoute, LayoutAdmin} from '@components'
import { HeaderProvider } from '@context/HeaderContext';



function AppRoutes() {
  return (
    <HeaderProvider>
      <Routes>
        <Route path="/" element={<Navigate to="/main" />}/>
        <Route element={<SignupLayout />}>
          <Route path="/main" element={<Layout><Main /></Layout>}/>
          <Route path="/findid" element={<Layout title="아이디 찾기"><FindId /></Layout>}/>
          <Route path="/terms" element={<Layout title="회원가입"><Terms /></Layout>}/>
          <Route path="/verify" element={<ProtectedVerifyRoute><Layout title="회원가입"><Verify /></Layout></ProtectedVerifyRoute>}/>
          <Route path="/signup" element={<ProtectedSignupRoute><Layout title="회원가입"><Signup /></Layout></ProtectedSignupRoute>}/>
        </Route>


        <Route path="/safety" element={<Layout title="안전보건교육소개"><SafetyEducation /></Layout>} />
        <Route path="/safety/management" element={<Layout title="안전보건교육소개"><SafetyManagement /></Layout>} />
        <Route path="/safety/worker" element={<Layout title="안전보건교육소개"><SafetyWorker /></Layout>} />
        <Route path="/safety/risk" element={<Layout title="안전보건교육소개"><SafetyRisk /></Layout>} />

        <Route path="/lecture" element={<Layout title="교육신청"><LectureList /></Layout>} />
        <Route path="/lecture/detail/:lectureId" element={<Layout title="교육신청"><LectureDetail /></Layout>} />


        <Route path="/apply/online" element={<Layout title="온라인교육 신청"><ApplyOnline /></Layout>} />

        <Route path="/support/reference" element={<Layout title="자료실"><ReferenceList /></Layout>} />
        <Route path="/support/reference/detail" element={<Layout title="자료실"><ReferenceDetail /></Layout>} />

        <Route path="/myLectures/myStudentLectures" element={<ProtectedRoute roles={["ROLE_USER"]}><Layout title="나의 교육정보"><MyLecturesStudent /></Layout></ProtectedRoute>} />
        <Route path="/myLectures/myStudentLectures/:lectureId" element={<ProtectedRoute roles={["ROLE_USER"]}><Layout title="나의 교육정보"><MyStudentLectureDetail /></Layout></ProtectedRoute>} />
        <Route path="/myLectures/myCompletionStudent" element={<ProtectedRoute roles={["ROLE_USER"]}><Layout title="수료정보"><MyCompletionStudent /></Layout></ProtectedRoute>} />
        <Route path="/myLectures/myStudentProfile" element={<ProtectedStudentProfileRoute><Layout title="개인정보관리"><MyStudentProfile /></Layout></ProtectedStudentProfileRoute>} />
        <Route path="/myLectures/reconfirm-password/student" element={<ProtectedRoute roles={["ROLE_USER"]}><Layout title="개인정보관리"><MyPasswordStudentPage /></Layout></ProtectedRoute>} />

        <Route path="/payment/paymentComplete" element={<ProtectedRoute roles={["ROLE_USER"]}><Layout title="결제완료"><PaymentComplete /></Layout></ProtectedRoute>} />
        <Route path="/payment/paymentFail" element={<ProtectedRoute roles={["ROLE_USER"]}><Layout title="결제실패"><PaymentFail /></Layout></ProtectedRoute>} />
        <Route path="/payment/refundComplete" element={<ProtectedRoute roles={["ROLE_USER"]}><Layout title="환불완료"><RefundComplete /></Layout></ProtectedRoute>} />
        <Route path="/payment/refundFail" element={<ProtectedRoute roles={["ROLE_USER"]}><Layout title="환불실패"><RefundFail /></Layout></ProtectedRoute>} />


        
        <Route path="/support/notice" element={<Layout title="공지사항"><NoticeList /></Layout>} />
        <Route path="/support/notice/detail" element={<Layout title="공지사항"><NoticeDetail /></Layout>} />
        <Route path="/support/qna" element={<Layout title="Q & A"><Qna /></Layout>} />


        <Route path="/mgr/login" element={<LoginPage />} />


        <Route path="/master" element={
            <ProtectedRoute roles={["ROLE_ADMIN"]}>
              <LayoutAdmin>
                <Outlet />
              </LayoutAdmin>
            </ProtectedRoute>
          }>
            <Route path="main" element={<MainAdmin />} />

            <Route path="comp" element={<Company />} />
            <Route path="integ" element={<Integration />} />
            <Route path="lecture" element={<Lecture />} />
            <Route path="lectureForm" element={<LectureForm />} />
            <Route path="lecture/:lectureId" element={<LectureDetails />} />
            <Route path="lectureStudent/:lectureId" element={<LectureStudent />} />
            <Route path="lectureAttend/:lectureId" element={<LectureAttendance />} />
            <Route path="lectureApply/:lectureId" element={<LectureApply />} />
            <Route path="lectureInvoice/:lectureId" element={<LectureInvoice />} />
            <Route path="instr" element={<Instructor />} />
            <Route path="instrResult" element={<InstructorResult />} />
            <Route path="mem" element={<Member />} />
            <Route path="inqu" element={<Inquiry />} />
            <Route path="notice" element={<Notice />} />
            <Route path="refer" element={<Reference />} />

            <Route path="memall" element={<MemberExcelRegist />} />

            <Route path="invoice" element={<Invoice />} />

        </Route>


        <Route path="*" element={<NotFound />} />
      </Routes>
    </HeaderProvider>
  );
}

export default AppRoutes;
